'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};
//# sourceMappingURL=LikeSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeSize.js
// module id = 1025
// module chunks = 198517197184460